import SpotlightLiveAccessV2 from './SpotlightLiveAccessV2'

export default SpotlightLiveAccessV2
// eslint-disable-next-line import/export
export * from './SpotlightLiveAccessV2'
